export default __webpack_public_path__ + "static/background-5e50911bad16f8989a9680e984cb760e.mp4";